<template>
  <div>
    <chc-modal title="Upload Logo" ref="uploadLogoModal">
      <div slot="body">
        <upload-logo v-on:refresh="refresh"
                     v-on:close="uploadLogoClose"
                     :charityId="data.charity_id"
        ></upload-logo>
      </div>
    </chc-modal>
    <div class="wrapper">
        <h2>Charity Logo</h2>
        <p>File types: .png or .svg preferred, .jpg or .gif also accepted.</p>
        <p>File should be a minimum of 300 pixels wide with 72 dpi resolution. A .png file with a transparent background will work best. The image will be displayed on a white background. A preview will show below after uploading your image</p>
        <p v-if="!data.logo"><a @click="uploadLogoOpen"><span class="icon fas fa-upload" aria-hidden="true"></span> Upload Logo</a></p>
        <img ref="image" id="logo" v-if="refreshed && data.logo" :src="$store.functions.charity.displayLogo(data.charity_id)">
        <p v-if="data.logo"><a @click="uploadLogoOpen"><span class="icon fas fa-upload" aria-hidden="true"></span> Upload New Logo</a></p>
        <hr>
        <h2>Donation Widget Code</h2>
        <p>Copy the code below and paste on the page you want to show the donation widget.</p>
        <textarea disabled v-model="iframe"></textarea>
        <hr>
        <h2>Widget Preview</h2>
        <p>Below is a preview of what the widget will look like on your site.</p>
        <img src="static/widget-example.png" alt="Donation Widget Preview">
    </div>
  </div>
</template>

<script>
import UploadLogo from '@/components/Widgets/UploadLogo'
import store from '@/store'

export default {
  name: 'DonationPreview',
  data () {
    return {
      data: {},
      refreshed: true,
    }
  },
  beforeRouteEnter (to, from, next) {
    let charityData = null
    Promise.all([
      store.functions.preview.getCharity((response) => { charityData = response.data })
    ]).then(() => {
      next(vm => vm.setData(charityData))
    })
  },
  mounted () {
  },
  computed: {
    iframe () {
      return "<iframe src='' style='width: 100%; max-width: 440px; height: 800px;'></iframe>"
    }
  },
  methods: {
    uploadLogoOpen () {
      this.$refs.uploadLogoModal.show()
    },
    uploadLogoClose () {
      this.$refs.uploadLogoModal.hide()
    },
    refresh () {
      this.uploadLogoClose()
      this.refreshed = false
      store.functions.preview.getCharity((response) => { this.setData(response.data.data) })
    },
    setData (data) {
      this.data = data
      this.refreshed = true
    }
  },
  props: {
  },
  components: {
    UploadLogo
  }
}
</script>

<style lang="scss" scoped>
#logo {
  max-height: 300px;
}
iframe {
  border: 1px solid grey;
}
textarea {
  height: auto;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/PreviewAccount/DonationPreview.vue